/* app/ui/video/load */

define(
	'app/ui/video/load',[
		'jquery',
		'util/lazyload',
		'pubsub',
		'templayed'
	],

	function ($, LazyLoad) {

		var VideoLoad;

		return {
			init: function () {
				VideoLoad = this;

				// Run callback function after scrolling to playlist element triggers lazyScroll plugin
				// This will ensure the YouTube API and supporting files are only loaded when necessary
				// Will only run once - js hook removed once the playlist has been loaded
				LazyLoad.initLazyFunction({
					elems: $('.js-load-playlist'),
					callback: function () {
						var $thisGallery = $(this);
						if ($thisGallery.hasClass('js-load-playlist')) {
							$thisGallery.removeClass('js-load-playlist');
							VideoLoad._getPlaylist($thisGallery);
						}
					}
				});
				VideoLoad._initVideoEvent();
			},

			// Retrieves a JSON feed from YouTube Data API. Playlist ID must be added to the target element
			// YouTube API key needs to be configured for each project
			_getPlaylist: function ($thisGallery) {
				var youTubeApiKey = 'AIzaSyBKNLdelvex6o6IQaEsYFeKE5k2rQfKgkw';
				var playListId = $thisGallery.attr('data-playlistid');
				var dataUrl = 'https://www.googleapis.com/youtube/v3/playlistItems?part=contentDetails%2Csnippet&maxResults=20&playlistId=' + playListId + '&key=' + youTubeApiKey;

				$.ajax({
					url: dataUrl,
					dataType: "jsonp"
				}).done(
					$.proxy(VideoLoad._createGallery, $thisGallery[0])
				).fail(function () {
					$thisGallery.addClass('js-load-playlist');
				});
			},

			// var data = JSON response from YouTube API
			// var videos = array of JS objects with only required data from JSON repsonse
			// Function retrieves HTML from templates to be populated with the 'videos' array
			// Publish event to trigger any JS functions tied to the playlist layout (e.g. thumbnail show/hide all)
			_createGallery: function (data) {
				var videos;
				var playlist = data.items;
				var $thisGallery = $(this);
				var thumbnailsTemplate = $('#js-video-template-thumb').html();
				var mainVideoTemplate = $('#js-video-template-main').html();

				var imageMain = $(this).attr('data-videoImage');
				var imageMainLazyload = $(this).attr('data-videoImage-lazyload');
				var imageThumbLazyload = $(this).attr('data-thumbImage-lazyload');

				videos = VideoLoad._generateVideoData($thisGallery, playlist);
				VideoLoad._renderThumbs($thisGallery, videos, imageThumbLazyload, thumbnailsTemplate);
				VideoLoad._renderMain($thisGallery, videos[0], imageMain, imageMainLazyload, mainVideoTemplate);
				//$.publish( '/carousel/setup' );
			},

			// Render playlist thumbnails using videos array and template
			_renderThumbs: function ($thisGallery, videos, placeholder, template) {
				var $thumbnailList = $thisGallery.find('.js-playlist-thumbnails');
				for (var i = 0; i < videos.length; i++) {
					var currentVideo = videos[i];
					var thumbnailClass = "";
					currentVideo.placeholderThumb = placeholder;
					if (i >= 4 && !$thisGallery.hasClass('js-homepage-popup')) {
						thumbnailClass = "visuallyhidden";
					}
					if (!$thisGallery.hasClass('figure--half')) {
						thumbnailClass += " s-one-quarter";
					}
					currentVideo.thumbnailClass = thumbnailClass;
					VideoLoad._compileAndInsertTemplate($thumbnailList, template, currentVideo, 'append', true);
				}
				$thumbnailList.find('li').first().addClass('is-selected');
				//if (videos.length > 4) {
				//	VideoLoad._insertViewAllButton($thumbnailList);
				//}
			},

			// Render main placeholder image / video player element
			_renderMain: function ($thisGallery, video, image, lazyload, template) {
				var $videoContainer = $thisGallery.find('.js-video-container');
				video.placeholderMain = image !== '' ? image : video.imageLarge;
				video.imageMain = lazyload;
				//video.placeholderThumb = lazyload;
				VideoLoad._compileAndInsertTemplate($videoContainer, template, video, 'overwrite', true);
			},

			// utility function to overwrite / append built templates to DOM
			// Publish event to trigger any images within the templates to lazyload
			_compileAndInsertTemplate: function ($container, template, vars, action, lazyload) {
				var compiledTemplate;
				var insertionType = action === 'append' ? 'append' : 'html';
				template = template.replace(/(\r\n|\n|\r)/gm, '');
				compiledTemplate = templayed(template)(vars);
				$container[insertionType](compiledTemplate);

				if (lazyload === true) {
					$.publish('/lazyload/image', [$container.find('img')]);
				}
				
			},

			// Creates an array of JS objects with only required data from JSON repsonse
			_generateVideoData: function ($thisGallery, playlist) {
				var videos = [];

				$.each(playlist, function () {
					var videoDetails = this.snippet;
					var video = {
						title: videoDetails.title,
						description: videoDetails.description,
						videoId: videoDetails.resourceId.videoId,
						imageThumb: videoDetails.thumbnails.high.url,
						imageLarge: videoDetails.thumbnails.high.url
					};
					videos.push(video);
				});

				return videos;
			},

			// Inserts the 'View All' button to display all the playlist thumbnails
			_insertViewAllButton: function ($thumbnailList) {
				var $button = $('<div class="push--ends text--center"><button class="btn btn--full btn--zest js-playlist-more">Load More Moovies</button></div>');
				$thumbnailList.after($button);
				$button.on('click', '.js-playlist-more', { list: $thumbnailList }, VideoLoad._displayAllThumbnails);
			},

			// Removes the 'visuallyhidden' class of all the playlist thumbnails
			_displayAllThumbnails: function (event) {
				event.preventDefault();
				var $thumbnailList = event.data.list;
				$(this).fadeOut();
				$thumbnailList.find('.visuallyhidden').removeClass('visuallyhidden');
				$.publish('/lazyload/image', [$thumbnailList.find('img')]);
			},

			// Event listener for click on any video links (main video player or playlist thumbnails)
			_initVideoEvent: function () {
				$('.js-video-player').on('click', '.js-video', VideoLoad.loadVideo);
			},

			// Pulls in Common and YouTube video JS only when a video link has been clicked
			loadVideo: function (event) {
				event.preventDefault();
				var thisVid = this;
				if ($(this).hasClass('js-video-thumbnail')) {
					$('.js-playlist-thumbnails').find('li').removeClass('is-selected');
					$(this).closest('li').addClass('is-selected');
					// $('.js-video-figcaption').text($(this).attr('data-video-description'));
					if ($('.js-video-title').length) {
						$('.js-video-title').text($(this).attr('data-video-title'));
					}
				}
				require(['app/ui/video/common', 'app/ui/video/youtube'], function (VideoCommon, YouTube) {
					VideoCommon.init(thisVid);
					YouTube.init(thisVid);
				});
			}
		};
	}
);
